module.exports = __webpack_public_path__ + "img/24.43e64bd7.png";